
import { defineComponent } from 'vue'
import { AppButton } from '@shared/ui'
export default defineComponent({
  name: 'PaymentAlert',
  components: { AppButton },
  emits: ['closeModal']
})
